import { array, number, object } from "superstruct";

const ReviewsListInfoSchema = object({
    totalCount: number(),
    averageRating: number(),
    ratesInfo: array(
        object({
            rating: number(),
            countReview: number(),
        })
    ),
});

export default ReviewsListInfoSchema;
